import React from "react";
import { Button, message } from 'antd';
import getSize from "../../utils/getSize";
import NHFetch from "../../utils/NHFetch";
import NHTable from '../common/NHTable';
import {NHConfirm} from '../common/NHModal';
import NHExcel from './NHExcel';
import EditForm from './EditForm.js';
import css from './index.css';
import NHContainerFrame from '../common/NHContainerFrame';
import { hasAuth } from '../../utils/NHCore';
import Moment  from 'moment';


const basicUrl = "/mailingManagement";


/**
 * 快递单号管理
 * @author JiangHaoRan
 * @date 2021年7月21日 13:43:22
 * Version: 1.0
 */
class mailingManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedRows:{},
            formInitData:{},
            frameVisibleMap: {
                tableFlag:true,
                updateFlag:false,
                addFlag: false,
            },
            showOperationBtn: false, //是否显示删除操作按钮
        };
    }
    //设置当前页面显示
    setCurrentPageShow = (showFlagName) => {
        let frameVisibleMap = this.state.frameVisibleMap;
        for (let name in frameVisibleMap) {
            if (name == showFlagName) {
                frameVisibleMap[name] = true;
            } else {
                frameVisibleMap[name] = false;
            }
        }
        this.setState({
            frameVisibleMap: frameVisibleMap
        });
    }
    //关闭内嵌页面
    handleCloseFrame = () => {
        this.setCurrentPageShow('tableFlag');
        this.refs.nhTable.filterTableData();
    }

    //是否显示删除按钮
    rowSelectionChange = (selectedRowKeys) => {
        if (selectedRowKeys.length) {
            this.setState({
                showOperationBtn: true
            })
        } else {
            this.setState({
                showOperationBtn: false
            })
        }
    }

    //新增按钮点击事件
    handleAddBtnClick = () => {
        this.setState({formInitData: {}});
        this.setCurrentPageShow('addFlag');
    }

    //修改按钮点击事件
    handleUpdateBtnClick = (record) => {
        let data=record;
        this.setState({
            formInitData: data
            }, this.setCurrentPageShow('updateFlag'));
    }


    handleOtpBtnClick = () => {
        this.refs.nhTable.exportExcel('快递单信息');
    }

    //单行删除
    handleSingleDeleteBtnClick = (record) => {
        NHConfirm("是否确定删除这条数据？", () => {
            let pkid = record.PKID;
            this.handleDelete([pkid]);
        }, "warn");
    }

    //多行删除
    handleMultiDeleteBtnClick = () => {
        let selectedRowKeys = this.refs.nhTable.state.selectedRowKeys;
        if (selectedRowKeys && selectedRowKeys.length > 0) {

            NHConfirm("是否确定删除选中的多条数据？", () => {
                this.handleDelete(selectedRowKeys);
            }, "warn");

        } else {
            message.warning("请先选择需要删除的数据！");
        }
    }

    //新增确定
    handleAdd=()=>{
        this.refs.nhAddForm.validateFields((err, formData) => {
            if (err) {
                return;
            }
            let {yjsj}=formData
            let time=yjsj.valueOf()
            let date= Moment(time).format('YYYY-MM-DD HH:mm:ss')
            formData.yjsj=date
            NHFetch(basicUrl+'/insert','POST',formData).then(res =>{
                if (res){
                    if (res.data>=1){
                        message.success("新增成功！");
                        this.setCurrentPageShow('tableFlag'); //显示列表展示页面
                        this.refs.nhTable.filterTableData(); //刷新列表
                    }else {
                        message.error("新增失败，请联系管理员！");
                    }
                }})
        });
    }
    //修改确定
    handleUpdate=()=>{
        this.refs.nhUpdateForm.validateFields((err, formData) => {
            if (err) {
                return;
            }
            let {yjsj}=formData
            let time=yjsj.valueOf()
            let date= Moment(time).format('YYYY-MM-DD HH:mm:ss')
            formData.yjsj=date
            NHFetch(basicUrl+'/update','POST',formData).then(res =>{
                if (res){
                    if (res.data>=1){
                        message.success("修改成功！");
                        this.setCurrentPageShow('tableFlag'); //显示列表展示页面
                        this.refs.nhTable.filterTableData(); //刷新列表
                    }else {
                        message.error("修改失败，请联系管理员！");
                    }
                }})
        });
    }

    //删除操作
    handleDelete = (pkids) => {
        NHFetch(basicUrl + '/delete', 'POST', pkids)
            .then(res => {
                if (res) {
                    if (res.data>=1){
                        message.success("删除操作成功！");
                        this.refs.nhTable.filterTableData();
                    }
                }
            })
    }

    onImport = () => {
        this.refs.nhExcel.show();
    }

    handleImportSuccess=()=>{
        this.refs.nhTable.filterTableData();
    }


    render() {
        //列参数
        const columns = [
            {
                title: '序号',
                dataIndex: 'ROW_ID',
                width: '60px',
            }, {
                title: '考生号',
                width: '70px',
                dataIndex: 'KSH',
                searchType:"input"
            }, {
                title: '姓名',
                dataIndex: 'XM',
                width: '120px',
                search: 'input',
                searchType:"input"
            }, {
                title: '邮寄地址',
                dataIndex: 'YJDZ',
                width: '70px',
                search: 'input',
                searchType:"input"
            }, {
                title: '邮寄接收人',
                width: '50px',
                dataIndex: 'YJJSR',
                searchType:"input"
            }, {
                title: '通知书编号',
                width: '100px',
                dataIndex: 'TZSBH',
                searchType:"input"
            }, {
                title: '快递单号',
                width: '100px',
                dataIndex: 'KDDH',
                searchType:"input"
            }, {
                title: '邮寄时间',
                width: '100px',
                dataIndex: 'YJSJ',
                searchType:"input",
            }
        ];

        //行内操作
        const action = [
            {title: '修改', onClick: this.handleUpdateBtnClick, auth: 'zhxg_yxgl_jcsj_mailingManagement:update'},
            {title: '删除', onClick: this.handleSingleDeleteBtnClick, auth: 'zhxg_yxgl_jcsj_mailingManagement:delete'}
            // {title: '修改', onClick: this.handleUpdateBtnClick},
            // {title: '删除', onClick: this.handleSingleDeleteBtnClick}
        ];

        return (
            <div className={css.main_right_content} style={{ height: getSize().windowH - 123 }}>
                <div className={css.table} style={{display: this.state.frameVisibleMap.tableFlag ? 'block' : 'none'}}>
                    <NHTable
                        ref='nhTable'
                        rowKey={record => record.PKID}
                        sign={"zhxg_yxxt_mailingManagement_queryPage"}
                        columns={columns}
                        action={action}
                        rowSelectionChange={this.rowSelectionChange}>


                        {/*<Button type="primary" onClick={this.handleAddBtnClick}>新增</Button>*/}
                        {
                        hasAuth('zhxg_yxgl_jcsj_mailingManagement:add') ?
                        <Button type="primary" onClick={this.handleAddBtnClick}>新增</Button>
                        : null
                        }

                        {/*<Button type="primary" ghost onClick={this.onImport} style={{ marginLeft: 10 }}>导入</Button>*/}
                        {
                            hasAuth("zhxg_yxgl_jcsj_mailingManagement:import") ?
                                <Button type="primary" ghost onClick={this.onImport} style={{ marginLeft: 10 }}>导入</Button>
                                : undefined
                        }


                        {
                            hasAuth("zhxg_yxgl_jcsj_mailingManagement:export") ?
                            <Button type="primary" ghost onClick={this.handleOtpBtnClick} style={{ marginLeft: 10 }}>导出</Button>
                            : undefined
                        }
                        {/*<Button type="primary" ghost onClick={this.handleOtpBtnClick} style={{ marginLeft: 10 }}>导出</Button>*/}

                        {/*<Button type="danger" ghost style={{*/}
                        {/*marginLeft: 10,*/}
                        {/*display: this.state.showOperationBtn ? undefined : 'none'*/}
                        {/*}}*/}
                        {/*onClick={this.handleMultiDeleteBtnClick}>删除</Button>*/}

                        {
                            hasAuth('zhxg_yxgl_jcsj_mailingManagement:deleteMore') ?
                                <Button type="danger" ghost style={{
                                    marginLeft: 10,
                                    display: this.state.showOperationBtn ? undefined : 'none'
                                }}
                                        onClick={this.handleMultiDeleteBtnClick}>删除</Button>
                                : null
                        }

                    </NHTable>
                </div>

                <NHContainerFrame ref="nhAddModal"
                                  title="新增快递单信息"
                                  onCancel={this.handleCloseFrame}
                                  onOk={this.handleAdd}
                                  visible={this.state.frameVisibleMap.addFlag}
                >
                    <EditForm ref="nhAddForm" initFormData={this.state.formInitData }  />
                </NHContainerFrame>

                <NHContainerFrame ref="nhUpdateModal"
                                  title="修改快递单信息"
                                  visible={this.state.frameVisibleMap.updateFlag}
                                  onCancel={this.handleCloseFrame}
                                  onOk={this.handleUpdate}
                >
                    <EditForm ref="nhUpdateForm" initFormData={this.state.formInitData}   />
                </NHContainerFrame>

                <NHExcel
                    ref='nhExcel'
                    title={'邮寄信息导入'}
                    templateName={'邮寄信息导入模板.xlsx'}  //导入模板名称
                    templateSign={'邮寄信息导入模板.xlsx'}  //导入模板问标志，主要通过该标志获取文件
                    importUrl={'api/zhxg-yxxt/mailingManagement/importExcel'}
                    onSuccess={this.handleImportSuccess}
                    onCancel={this.onCancel}
                />

            </div>
        );
    }
}
export default mailingManagement;



// WEBPACK FOOTER //
// ./components/mailingManagement/mailingManagement.js